export const blogs = {
  blogsFeedCreateInputPlaceholder: 'Écrivez un message...',
  blogsFeedSearchInputPlaceholder: 'Rechercher',
  blogsFeedPostOwnerCurtainEditTitle: 'Modifier le message',
  blogsFeedPostOwnerCurtainDeleteTitle: 'Supprimer le message',
  blogsFeedEditedPostSavedAlertText: 'Message enregistré !',
  blogsFeedEditedPostDeletedAlertText: 'Message supprimé !',
  blogsFeedShareCurtainOptionTitle: 'Copier le lien',
  blogsFeedPostLinkCopiedAlertText: 'Lien copié !',
  blogsFeedOthersPostCurtainOptionCopyTitle: 'Copier le lien',
  blogsFeedOthersPosLinkCopiedAlertText: 'Lien copié !',
  blogsFeedOthersPostCurtainOptionFlagTitle: 'Signaler le contenu',
  blogsFeedOtherPostOwnersCurtainDeleteTitle: 'Supprimer le message',
  blogsFeedPostDeletePopupTitle: 'Supprimer',
  blogsFeedPostDeletePopupText: 'Supprimer ce message ?',
  blogsFeedPostDeletePopupCancelButtonTitle: 'Annuler',
  blogsFeedPostDeletePopupConfirmButtonTitle: 'Confirmer',
  blogsFeedPostDeeletedAlertText: 'Message supprimé !',
  blogsPostDetailsHeaderTitle: 'Message',
  postFeedPostLikesText: 'Likes',
  postFeedPostCommentsText: 'Commentaires',
  postFeedPostNoLikesText: "Il n'y a pas encore de likes",
  postFeedPostLeaveFirstLikeText: 'Vous pouvez être le premier à aimer',
  blogsFeedPostDetailsNoCommentsText: "Il n'y a pas encore de commentaires",
  blogsFeedPostDetailsFirstCommentText: 'Vous pouvez être le premier à commenter',
  blogsFeedPostDetailsShareOptionTitle: 'Copier le lien',
  blogsFeedPostDetailsSharePostCopiedAlertText: 'Lien copié !',
  blogsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Copier le lien',
  blogsFeedPostDetailsCopiedAlertText: 'Lien copié !',
  blogsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Signaler le contenu',
  blogsPostDetailsFlagCurtainOptionSpamTitle: 'Signaler',
  blogsPostDetailsReportedCurtainText: 'Contenu signalé',
  blogsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Modifier le commentaire',
  blogsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Supprimer le commentaire',
  blogsPostDetailsEditedCommentSavedAlertText: 'Commentaire enregistré !',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Supprimer le commentaire',
  postDetailsOtherUsersCommentDeletadAlertText: 'Commentaire supprimé !',
  postDetailsDeleteCommentPopupTitle: 'Supprimer',
  postDetailsDeleteCommentPopupText: 'Supprimer ce commentaire ?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Annuler',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmer',
  postDetailsCommDeletedAlertText: 'Commentaire supprimé !',
  postDetailsCommentUserCurtainOptionTitle: 'Signaler le commentaire',
  blogsCreatePostCurtainTitle: 'Nouveau message',
  blogsCreatePostCurtainBodyPlaceholder: 'Écrivez votre texte ici...',
  blogsCreatePostPublishButtonTitle: 'Publier',
  blogsCreatePostUploadSlallerImageAlertText: 'Vous ne pouvez télécharger que {size} Mo à la fois',
  blogsPostSavedAlertText: 'Message enregistré !',
  blogsCreatePostAddLocationCurtainTitle: 'Emplacement',
  blogsCreatePostAddLocationCurtainInputPlaceholder: "Nom de l'emplacement",
  blogsCreatePostEditLocationCurtainText: "Modifier l'emplacement",
  blogsDeleteLocation: "Supprimer l'emplacement",
  blogsDiscardPostPopupTitle: 'Brouillon',
  blogsDiscardPostPopupText: 'Supprimer ce brouillon ?',
  blogsDiscardPostPopupCancelButtonTitle: 'Annuler',
  blogsDiscardPostPopupCofirmButtonTitle: 'Confirmer',
  blogsNewPostCreatePollTitle: 'Créer un sondage',
  blogsNewPostCreatePollTitleInputPlaceholder: 'Titre',
  blogsNewPostCreatePollOptionInputPlaceholder: 'Option',
  blogsNewPostCreatePollAddButtonTitle: 'Ajouter une option',
  blogsNewPostCreatePollCreateButtonTitle: 'Créer',
  blogsCreatePostPollTitleBlankAlertText: 'Le titre ne peut pas être vide !',
  blogsCreatePostPollOptionBlankAlertText: "L'option ne peut pas être vide !",
  blogsCreatePostPollLongTitleAlertText: 'Le titre doit contenir au maximum {length} caractères',
  blogsCreatePostPollLongOptionAlertText: "L'option doit contenir au maximum {length} caractères",
  blogsCreatePostPollEditOptionTitle: 'Modifier le sondage',
  blogsCreatePostPollRemoveOptionTitle: 'Supprimer le sondage',
  blogsPostPollInfoVotesText: 'votes',
  blogsPostPollInfoEditVoteText: 'Modifier le vote',
  blogsPostPollFinishPollText: 'Terminer le sondage',
  blogsPostPollFinishedPollText: 'Terminé',
  blogsPostPollInProgresslText: 'En cours',
  blogsFinishPollCurtainTitle: 'Terminer le sondage',
  blogsFinishPollCurtainText: 'Les utilisateurs ne pourront plus voter une fois le sondage terminé.',
  blogsFinishPollCurtainCancelButtonTitle: 'Annuler',
  blogsFinishPollCurtainConfirmlButtonTitle: 'Confirmer',
  blogsPollInfoPollVotesCurtainTitle: 'Votes du sondage',
  blogsEditPostCurtainTitle: 'Modifier le message',
  blogsEditPostCurtainNoTextBodyPlaceholder: 'Écrivez votre texte ici...',
  blogsEditPostCurtainSaveButtonTitle: 'Enregistrer',
  blogsEditPostSavedAlertText: 'Message enregistré !',
  blogsError: "Quelque chose s'est mal passé !",
  blogsAt: 'à',
  blogsSeeMore: 'Voir plus...',
  blogsMaxAttachments: 'Vous avez dépassé le nombre maximal de pièces jointes. Le nombre maximal de pièces jointes est {length}',
  blogsReply: 'Répondre',
  blogsAddCover: 'Ajouter une image de couverture'
}
